import React from 'react'
import { OffersQueryVariables } from 'src/common/apollo/types/swarmx/graphql'
import useBreakpoint from 'src/common/hooks/ui/useBreakpoint'
import OffersFilterDesktop from './OffersFilterDesktop/OffersFilter.desktop'
import OffersFilterMobile from './OffersFilterMobile/OffersFilter.mobile'

export interface OffersFilterProps {
  onFilterChange: (filters: OffersQueryVariables['filter']) => void
}

const OffersFilter: React.FC<OffersFilterProps> = ({ onFilterChange }) => {
  const isMd = useBreakpoint('md')

  if (isMd) return <OffersFilterMobile onFilterChange={onFilterChange} />
  return <OffersFilterDesktop onFilterChange={onFilterChange} />
}

export default OffersFilter
